<template>
 <div class="hello">
     <div class="ps-page--my-account">
        <div class="ps-breadcrumb">
            <div class="container">
                <ul class="breadcrumb">

                    <li>{{message}}</li>
                </ul>
            </div>
        </div>
        <div class="ps-my-account">
            <div class="container">

            </div>
        </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
export default {
  name: 'Activation',
  data () {
    return {
      state : false,
      id: this.$route.params.id,
      message: '',

    }
  },
   methods: {

     activateAccount(){

   var dataa = {"activation":this.id};

    DataService.activate_account_post(dataa)
        .then(response => {

          //console.log(response.data);
          this.message = this.$parent.translate_error_message(response.data,"message");

        })
        .catch(error => {
          console.log(error.response);
          this.message = this.$parent.translate_error_message(error.response.data.errors,"errors");
          //console.log(error.response.data.errors);
        });
     }



   },
   created(){
        // console.log($route.params.id);
         console.log("we are in the created function");
         this.activateAccount();

     }


}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Activation.vue